import { createFileRoute } from "@tanstack/react-router";
import { EmailLogPage } from "@/features/admin/email-log-page";
import { ensureSuperAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/email-log")({
	beforeLoad: async () => {
		await ensureSuperAdminAccess();
	},
	component: EmailLogPage,
});
